const en = {
	'common.save': 'Save',
	'common.logout': 'Logout',
	'common.signIn': 'Sign in',
	'common.rename': 'Rename',
	'common.delete': 'Delete',
	'common.sources': 'Sources',
	'common.hello': 'Hello',
	'common.by': 'by',
	'common.and': 'and',
	'common.privacy': 'Privacy Policy',
	'common.imprint': 'Imprint',
	'common.terms': 'Terms and Conditions',
	'common.copy': 'Copy',
	'common.copied': 'Copied!',
	'common.close': 'Close',

	'releaseNotes.title': 'Release Notes',
	'releaseNotes.current': 'Current Version',
	'releaseNotes.previous': 'Previous Versions',
	'releaseNotes.userView': 'User View',

	'error.network': 'Connection lost. Please check your internet connection and try again.',
	'error.overloaded': 'The service is temporarily overloaded. Please try again in a moment.',
	'error.notFound': 'Not found',
	'error.unknown': 'Unknown Error',

	'nav.data': 'Knowledge Store',
	'nav.briefing': 'Daily Briefing',
	'nav.history': 'All Chats',
	'nav.tenantAdminSettings': 'Admin Settings',
	'nav.users': 'User Management',
	'nav.recentChats': 'Recent Chats',

	'users.title': 'User Management',
	'users.empty': 'No users found',
	'users.role': 'Role',
	'users.role.user': 'User',
	'users.role.operator': 'Operator',
	'users.role.admin': 'Admin',
	'users.conversations': 'Conversations',
	'users.messages': 'Messages',
	'users.tokens': 'Tokens',
	'users.created': 'Created',
	'users.lastActivity': 'Last Activity',
	'users.never': 'Never',
	'users.plan': 'Plan',
	'users.delete': 'Delete User',
	'users.delete.confirm': 'Delete this user?',
	'users.delete.warning': 'This will permanently delete the user account and all associated data.',
	'users.itsYou': "it's you",
	'users.search': 'Search users…',

	'briefing.title': 'Daily Briefing',
	'briefing.heading': 'Daily Parliamentary Briefing from {{date}}',
	'briefing.emptyState': 'No briefing available for today. Check back tomorrow!',
	'briefing.loading': "Loading today's briefing...",
	'briefing.errorLoading': 'Error loading briefing',
	'briefing.coveragePeriod': 'Coverage period',
	'briefing.generatedOn': 'Generated on',
	'briefing.footer.whatAre': 'What are daily briefings?',
	'briefing.footer.description':
		'Daily briefings are automatically generated summaries of parliamentary activity. They provide a concise overview of the most important debates, decisions, and discussions.',
	'briefing.footer.howGenerated': 'How are they generated?',
	'briefing.footer.generationProcess':
		'Our AI system analyzes all parliamentary documents and speeches from the past day, identifies key topics, and creates a structured summary.',
	'briefing.footer.whenGenerated': 'When are they generated?',
	'briefing.footer.schedule':
		'Briefings are generated early in the morning and cover topics from the previous day.',

	'auth.signIn.title': 'Sign in',
	'auth.signIn.titleWithTenant': 'Sign in to {{tenant}}',
	'auth.signIn.subtitle': 'Sign in to your Botbakery account to get started.',
	'auth.signIn.signinSubtitle': 'Enter your password to continue to your Botbakery account.',
	'auth.signIn.email': 'Email',
	'auth.signIn.password': 'Password',
	'auth.signIn.continueWithEmail': 'Continue',
	'auth.signIn.or': 'or',
	'auth.signIn.signInWithGoogle': 'Continue with Google',
	'auth.signIn.signInWithMicrosoft': 'Continue with Microsoft',
	'auth.signIn.forgotPassword': 'Forgot password?',
	'auth.signIn.createAccount': 'Create an account',
	'auth.signIn.welcome': 'Welcome!',
	'auth.signIn.welcomeBack': 'Welcome back!',
	'auth.signIn.invalidEmail': 'Please enter a valid email address',
	'auth.signIn.fillAllFields': 'Please fill in all fields',

	'auth.reset.title': 'Reset Password',
	'auth.reset.message':
		"Enter the email associated with your account and we'll send you a recovery link",
	'auth.reset.success':
		'Requested a password reset for {email}. If this email is associated with a {{tenantName}} account, you have received an email with a reset link.',
	'auth.reset.backToLogin': 'Back to login',
	'auth.reset.email': 'Email',
	'auth.reset.submit': 'Send Reset Link',
	'auth.reset.error': 'Error resetting password',
	'auth.confirmReset.title': 'New Password',
	'auth.confirmReset.success':
		'Password was successfully set! You can now login with your new password.',
	'auth.confirmReset.message': 'Please set a new password',
	'auth.confirmReset.password': 'Password',
	'auth.confirmReset.passwordConfirm': 'Confirm Password',
	'auth.confirmReset.submit': 'Save',
	'auth.confirmReset.toLogin': 'Go to login',

	'auth.signup.title': 'Create your account',
	'auth.signup.subtitle': 'Just a few details to set up your Botbakery account.',
	'auth.signup.firstName': 'First name',
	'auth.signup.lastName': 'Last name',
	'auth.signup.password': 'Password',
	'auth.signup.passwordConfirm': 'Confirm password',
	'auth.signup.passwordsNotEqual': 'Passwords are not equal',
	'auth.signup.submit': 'Create account',
	'auth.signup.notApproved':
		'Unfortunately your account has not been approved yet. Please try again later.',
	'auth.signup.success': 'Your account has been successfully created! You can now log in.',
	'auth.signup.toLogin': 'Go to login',
	'auth.signup.needInfo': 'We need a bit more information from you',
	'auth.signup.acceptTerms': 'I accept the {{terms}} and {{privacy}}',
	'auth.signup.termsRequired': 'You must accept the terms and conditions',
	'auth.signup.fillAllFields': 'Please fill in all required fields',

	'auth.unsubscribe.title': 'Unsubscribe',
	'auth.unsubscribe.success': 'Your email has been successfully deleted from our system.',
	'auth.unsubscribe.confirmMessage': 'Sorry to see you want to leave the waitlist.',
	'auth.unsubscribe.confirmQuestion': 'Are you sure?',
	'auth.unsubscribe.submit': 'Yes, delete my email address',
	'auth.verify.successTitle': 'Email confirmed!',
	'auth.verify.successMessage':
		'Your email address has been verified. You can now sign in to your account.',
	'auth.verify.toLogin': 'Sign in',
	'auth.verify.errorTitle': 'Error',
	'auth.verify.errorMessage': 'Unfortunately there was an error during verification :(',

	'chat.welcome': 'how can I help you today?',
	'chat.new': 'New Chat',
	'chat.info': 'Chat Info',
	'chat.rename': 'Rename Chat',
	'chat.delete': 'Delete Chat',
	'chat.delete.question': 'Do you really want to delete this chat?',
	'chat.delete.confirm': 'Yes, delete',
	'chat.delete.cancel': "No, don't delete",
	'chat.disclaimer': '{{tenantName}} can make mistakes',
	'chat.disclaimerCheckSources': 'Always check all sources carefully',
	'chat.developedBy': 'Developed by',
	'chat.placeholder': 'Ask me anything...',
	'chat.debugInfo': 'Debug Info',
	'chat.retry': 'Regenerate',
	'chat.regenerate': 'Regenerate',
	'chat.incomplete': 'Response interrupted',
	'chat.incompleteTooltip': 'You stopped the generation of the response before it was finished',
	'chat.stopResponse': 'Stop response',
	'chat.webSearchEnabledLabel': 'Allow searching the web for additional information',
	'chat.lastMessage': 'Last message',
	'chat.emptyHistory': 'No chats available',
	'chat.unnamed': 'Unnamed Chat',
	'chat.fetching.thinking': 'thinking...',
	'chat.fetching.analyticalQuery': 'querying database...',
	'chat.fetching.searchSources': 'searching for sources...',
	'chat.fetching.sourcesFound': 'sources found...',
	'chat.reasoning': 'Thinking',

	'data.emptyState': 'No data available',
	'data.importedOn': 'Imported on',
	'data.document': 'document',
	'data.documents': 'documents',
	'data.speech': 'speech',
	'data.speeches': 'speeches',
	'data.openSource': 'Open source',
	'data.loadError': 'Error loading data',
	'data.latestUpdate': 'Latest Update',
	'data.documentsInKnowledgeStore': 'Documents in Knowledge Store*',
	'data.documentTypesExplanation':
		'* Documents include various types of content such as speeches, articles, laws, and other documents.',
	'data.description':
		'We regularly update this knowledge base with new data. All information listed here is available for the bot to search through and reference in conversations. If something is not listed on this page, the bot will not have access to it.',
	'data.topicsInDebate': 'Topics in this debate:',
	'data.tabs.resources': 'Resources',
	'data.tabs.importJobs': 'Import Jobs',

	'data.noDocuments': 'No documents in this resource',

	'docType.speech': 'Debate in Bundestag',
	'docType.politician_bio': 'Person',
	'docType.eu_com_proposal': 'Commission Proposal',
	'docType.eu_ep_amendments_adopted': 'Adopted Amendments',
	'docType.eu_ep_cmt_opinion': 'Committee Opinion',
	'docType.eu_egp_briefing': 'EGP Internal Briefing',
	'docType.press_message': 'Parliamentary News "heute im bundestag"',
	'docType.podcast_transscript': 'Podcast Transcript',
	'docType.generic_document': 'Document',

	'sources.header': 'Source Documents',
	'sources.headerDetail': 'Source Document',
	'sources.documents': 'Documents',
	'sources.documentLink': 'Document Link',
	'sources.metadata': 'Metadata',
	'sources.summary': 'Summary',
	'sources.originalText': 'Original Text',
	'sources.placeholder':
		'Sources and context information will show up here, once you start the conversation',
	'sources.primarySources': 'Knowledge Base',
	'sources.webSources': 'Web Sources',
	'sources.openWebSource': 'Open Web Page',
	'sources.description': 'Description',
	'sources.citedPassages': 'Cited Passages',
	'sources.copyrightNotice':
		'Only cited excerpts are shown here. Visit the source link to read the full content.',

	'settings.locale': 'Language',
	'settings.locale.en': 'English',
	'settings.locale.de': 'German',

	'settings.theme': 'Theme',
	'settings.theme.light': 'Light',
	'settings.theme.dark': 'Dark',
	'settings.theme.system': 'System Default',

	'settings.title': 'Settings',
	'settings.user.name': 'Name',
	'settings.user.firstName': 'First Name',
	'settings.user.lastName': 'Last Name',
	'settings.user.bio': 'Bio',
	'settings.user.email': 'Email',
	'settings.user.username': 'Username',
	'settings.user.defaultModel': 'Default Model',
	'settings.user.defaultEmbeddingsVendor': 'Default Embeddings Model',

	'settings.deleteAccount': 'Delete Account',
	'settings.deleteAccount.title': 'Delete Your Account',
	'settings.deleteAccount.warning':
		'This action will schedule your account for deletion. All your data including conversations, settings, and personal information will be permanently removed.',
	'settings.deleteAccount.gracePeriod':
		'You have 30 days to change your mind. During this period, you can contact support to restore your account. After 30 days, all data will be permanently deleted.',
	'settings.deleteAccount.confirm': 'Yes, delete my account',
	'settings.deleteAccount.cancel': 'Cancel',

	'settings.tenant.title': 'Tenant Settings',
	'settings.tenant.name': 'Tenant Name',
	'settings.tenant.primer': 'Primer',
	'settings.tenant.logo': 'Logo',
	'settings.tenant.language': 'Language',
	'settings.tenant.onboardingContent': 'Onboarding Content (Popup on first Login)',
	'settings.tenant.responseStyle': 'Response Style',
	'settings.tenant.knowledgeBase': 'Knowledge Base Context',
	'settings.tenant.featureFlags': 'Feature Flags',
	'settings.tenant.dailyBriefing': 'Daily Briefing',
	'settings.tenant.webSearch': 'Web Search',
	'settings.tenant.generalSettings': 'General Settings',
	'settings.tenant.systemPrompt': 'System Prompt',
	'settings.tenant.chatSuggestions': 'Chat Suggestions',
	'settings.tenant.chatSuggestions.description':
		'Suggestions appear as clickable bubbles on the new chat page',
	'settings.tenant.chatSuggestions.placeholder': 'Enter a suggestion...',
	'settings.tenant.chatSuggestions.add': 'Add',
	'settings.tenant.chatSuggestions.empty': 'No suggestions added yet',
	'settings.tenant.knowledgeBase.flag': 'Knowledge Base',
	'settings.tenant.knowledgeBase.flag.description':
		'Enables access to vector search, keyword search, and document retrieval tools.',
	'settings.tenant.knowledgeBase.citationEngine': 'Citation Engine',
	'settings.tenant.knowledgeBase.citationEngine.description':
		'Requires the agent to cite sources with exact quotes. Disable for assistants that do not need strict source attribution.',
	'settings.tenant.dailyBriefing.description': 'Daily Briefing sub-page is visible.',
	'settings.tenant.webSearch.description':
		'Web search as secondary source for supplementary information.',
	'settings.tenant.webSearch.alwaysOn': 'Always On',
	'settings.tenant.webSearch.alwaysOn.description':
		'Web search is always active. The user toggle in the chat input is hidden.',
	'settings.tenant.queryClassification': 'Query Classification',
	'settings.tenant.queryClassification.description':
		'Classifies queries before processing to skip retrieval and thinking for simple requests. Disable for models with adaptive thinking.',
	'settings.tenant.allowedSearchDomains': 'Allowed Search Domains',
	'settings.tenant.allowedSearchDomains.description':
		'Restrict web search to these domains. Leave empty to allow all domains.',
	'settings.tenant.allowedSearchDomains.placeholder': 'e.g. tagesschau.de',
	'settings.tenant.allowedSearchDomains.add': 'Add',
	'settings.tenant.allowedSearchDomains.empty': 'No domains added — all domains are allowed',
	'settings.tenant.welcomeMessage': 'Welcome Message',
	'settings.tenant.welcomeMessage.description':
		'Custom welcome message shown on the new chat page. Leave empty to use the default.',
	'settings.tenant.defaultModel': 'Default Foundation Model',

	'settings.tenant.nav.header': 'Admin Settings',
	'settings.tenant.nav.back': 'Back',
	'settings.tenant.nav.general': 'General',
	'settings.tenant.nav.knowledgeBase': 'Knowledge Base',
	'settings.tenant.nav.webSearch': 'Web Search',
	'settings.tenant.nav.queryClassification': 'Query Classification',
	'settings.tenant.nav.apiKeys': 'API Keys',

	'settings.tenant.defaultClassification': 'Default Classification',
	'settings.tenant.defaultClassification.description':
		'Behavior when query classification is disabled. These settings define how every query is handled.',
	'settings.tenant.defaultClassification.enableThinking': 'Enable Thinking',
	'settings.tenant.defaultClassification.hideThinking': 'Hide Thinking',
	'settings.tenant.defaultClassification.enableTools': 'Enable Tools',
	'settings.tenant.defaultClassification.temperature': 'Temperature',
	'settings.tenant.defaultClassification.maxIterations': 'Max Iterations',

	'tenant.create.title': 'New Tenant',
	'tenant.create.name': 'Tenant Name',
	'tenant.create.slug': 'Slug (URL identifier)',
	'tenant.create.language': 'Language',
	'tenant.create.submit': 'Create Tenant',
	'tenant.create.tooltip': 'Create Tenant',

	'apiKeys.title': 'API Keys',
	'apiKeys.createNew': 'Create New Key',
	'apiKeys.noKeys': 'No API keys yet. Create one to get started.',
	'apiKeys.active': 'Active',
	'apiKeys.inactive': 'Inactive',
	'apiKeys.created': 'Created',
	'apiKeys.lastUsed': 'Last used',
	'apiKeys.expires': 'Expires',
	'apiKeys.neverExpires': 'Never expires',
	'apiKeys.requests': 'requests',
	'apiKeys.deleteConfirm': 'Are you sure you want to delete the API key "{{name}}"?',

	'sharedLinks.title': 'Shared Links',
	'sharedLinks.createNew': 'Create Shared Link',
	'sharedLinks.noLinks': 'No shared links yet. Create one to get started.',
	'sharedLinks.deleteConfirm': 'Are you sure you want to delete this shared link?',
	'sharedLinks.create.title': 'Create Shared Link',
	'sharedLinks.create.generating': 'Generating shared link...',

	'apiKeys.create.title': 'Create API Key',
	'apiKeys.create.keyName': 'Key Name',
	'apiKeys.create.keyType': 'Key Type',
	'apiKeys.create.keyType.widget': 'Widget',
	'apiKeys.create.keyType.sharedLink': 'Shared Link',
	'apiKeys.create.allowedOrigins': 'Allowed Origins (comma-separated)',
	'apiKeys.create.validityPeriod': 'Validity Period',
	'apiKeys.create.neverExpires': 'Never expires',
	'apiKeys.create.days': '{{count}} days',
	'apiKeys.create.year': '1 year',
	'apiKeys.create.anonymousConversations': 'Anonymous Conversations',
	'apiKeys.create.anonymousConversationsHelp':
		'Check this if you want to use it for embedding the widget',
	'apiKeys.create.submit': 'Create Key',
	'apiKeys.create.warning':
		"Make sure to copy your API key now. You won't be able to see it again!",
	'apiKeys.create.copyToClipboard': 'Copy to Clipboard',
	'apiKeys.create.done': 'Done',
	'apiKeys.create.sharedLinkSuccess': 'Share this link with others:',

	'onboarding.title': 'Welcome!',
	'onboarding.getStarted': 'Get Started',
	'onboarding.showDialog': 'Show welcome dialog',

	'plan.free': 'Free',
	'plan.basic': 'Basic',
	'plan.unlimited': 'Unlimited',
	'plan.conversations': '{{current}}/{{max}} conversations',
	'plan.conversationsUnlimited': 'Unlimited conversations',
	'plan.upgrade': 'Upgrade Plan',
	'plan.upgrade.title': 'Upgrade Your Plan',
	'plan.upgrade.description':
		'Get more conversations and messages per conversation by upgrading your plan.',
	'plan.upgrade.currentPlan': 'Current Plan',
	'plan.upgrade.features': 'Features',
	'plan.upgrade.conversationsLimit': '{{count}} conversations',
	'plan.upgrade.conversationsUnlimited': 'Unlimited conversations',
	'plan.upgrade.messagesLimit': '{{count}} messages per conversation',
	'plan.upgrade.messagesUnlimited': 'Unlimited messages per conversation',
	'plan.upgrade.custom': 'Custom',
	'plan.upgrade.customDataIntegration': 'Custom data integration',
	'plan.upgrade.dedicatedSupport': 'Dedicated support contact',
	'plan.upgrade.widgetEmbedding': 'Widget embedding',
	'plan.upgrade.customBranding': 'Custom branding',
	'plan.upgrade.higherPerformanceModels': 'Higher performance foundation models',
	'plan.upgrade.chooseModelPerRequest': 'Choose the model for each request',
	'plan.upgrade.ownModelIntegration': 'Integrate your own model',
	'plan.upgrade.onPremise': 'On-premise deployment',
	'plan.upgrade.earlyAdopterTitle': 'Early Adopter Bonus',
	'plan.upgrade.earlyAdopterDescription':
		'As a reward for joining Botbakery early, double your limits for free!',
	'plan.upgrade.claimBonus': 'Claim Bonus',
	'plan.upgrade.comingSoon': 'Coming soon',
	'plan.upgrade.contact': 'Contact Us',
	'plan.upgrade.contactDescription': 'Interested in upgrading? Get in touch with us.',
	'plan.upgrade.earlyAdopterNotice':
		'You are on the Basic plan as a thank you for being an early adopter!',
	'plan.limitReached.title': 'Conversation limit reached',
	'plan.limitReached.description':
		"You've used all {{count}} conversations in your {{plan}} plan. Upgrade to continue chatting.",
	'plan.limitReached.cta': 'Upgrade Plan',

	// Landing Page
	'landing.hero.brandTag': 'A service by',
	'landing.hero.headline': 'The chatbot platform you can trust',
	'landing.hero.subheadline':
		'Botbakery Platform integrates your knowledge sources with the LLM of your choice. With verifiable citations, GDPR-compliant, and hosted in the EU.',
	'landing.hero.cta': 'Book a demo',

	// Value Propositions
	'landing.benefits.heading': 'Why Choose Botbakery?',
	'landing.benefits.citations.title': 'Verifiable answers through precise citations',
	'landing.benefits.customKnowledge.title': 'Custom knowledge integrated for you',
	'landing.benefits.verifiable.title': 'Verifiable Answers',
	'landing.benefits.verifiable.text':
		'Every answer includes full source citations, so you can verify information and prevent hallucinations.',
	'landing.benefits.private.title': 'Your Private Knowledge',
	'landing.benefits.private.text':
		'Integrate internal documents, wikis, and databases. Your knowledge stays secure and private.',
	'landing.benefits.gdpr.title': 'GDPR Compliant',
	'landing.benefits.gdpr.text':
		'Hosted in the EU with full GDPR compliance. Your data never leaves Europe.',
	'landing.benefits.custom.title': 'Custom Integrations',
	'landing.benefits.custom.text':
		'Deploy via API, web widget, or custom integration. Built for your workflow.',

	// How It Works
	'landing.howItWorks.heading': 'How It Works',
	'landing.howItWorks.step1.title': 'Connect Your Knowledge',
	'landing.howItWorks.step1.description':
		'Import documents, wikis, databases, and any knowledge sources your organization uses.',
	'landing.howItWorks.step2.title': 'Customize Your Assistant',
	'landing.howItWorks.step2.description':
		'Configure RAG parameters, select AI models, and customize for your domain.',
	'landing.howItWorks.step3.title': 'Deploy Anywhere',
	'landing.howItWorks.step3.description':
		'Use via API, embed as a widget, or integrate into your existing tools.',

	// RAG Pipeline (detailed)
	'landing.ragPipeline.heading': 'How Does the Botbakery Platform Work?',
	'landing.ragPipeline.intro':
		'Retrieval-Augmented Generation (RAG) combines targeted document search with modern AI language capabilities. Unlike generic chatbots that answer "from the gut," Botbakery Platform first retrieves relevant facts from your databases—then generates a precise answer based on these sources. The result: reliable, verifiable answers instead of hallucinated "facts."',
	'landing.ragPipeline.step1.title': 'Document Preprocessing',
	'landing.ragPipeline.step1.description':
		'We process your documents with intelligent chunking, create summaries, and extract metadata for optimal searchability',
	'landing.ragPipeline.step2.title': 'Intent Detection',
	'landing.ragPipeline.step2.description':
		'We analyze the user query to understand their intention—this guides the pipeline toward more relevant results and determines whether retrieval is needed or if the model can answer directly',
	'landing.ragPipeline.step3.title': 'Multi-Stage Retrieval',
	'landing.ragPipeline.step3.description':
		'We run retrieval multiple times in successive stages, each time getting closer to the required knowledge—starting broad with document summaries, then narrowing down to specific passages',
	'landing.ragPipeline.step4.title': 'Reranking',
	'landing.ragPipeline.step4.description':
		'We rerank all retrieved results by actual relevance to the specific question, selecting the optimal information for the AI context',
	'landing.ragPipeline.step5.title': 'Response Generation & Citation',
	'landing.ragPipeline.step5.description':
		'We generate a precise answer based on the retrieved sources and automatically insert citations that link every statement back to the original documents for full transparency',

	// Use Cases
	'landing.useCases.heading': 'Built for Your Workflow',
	'landing.useCases.internal.title': 'Internal Knowledge Management',
	'landing.useCases.internal.description':
		'Give your team instant access to company knowledge, policies, and documentation.',
	'landing.useCases.customer.title': 'Customer Success',
	'landing.useCases.customer.description':
		'Automate support with accurate, source-cited answers to customer questions.',
	'landing.useCases.technical.title': 'Technical Documentation',
	'landing.useCases.technical.description':
		'Help developers find API details, code examples, and integration guides.',
	'landing.useCases.research.title': 'Research & Analysis',
	'landing.useCases.research.description':
		'Search through reports, studies, and data with AI-powered insights.',

	// Comparison
	'landing.comparison.heading': 'Why Not Just Use ChatGPT?',
	'landing.comparison.sources': 'Source Citations',
	'landing.comparison.astlai.sources': 'Full citations for every answer',
	'landing.comparison.chatgpt.sources': 'No source references',
	'landing.comparison.knowledge': 'Private Knowledge',
	'landing.comparison.astlai.knowledge': 'Full access to your documents',
	'landing.comparison.chatgpt.knowledge': 'Only public training data',
	'landing.comparison.compliance': 'GDPR Compliance',
	'landing.comparison.astlai.compliance': 'EU-hosted, GDPR compliant',
	'landing.comparison.chatgpt.compliance': 'US-hosted',
	'landing.comparison.customization': 'Customization',
	'landing.comparison.astlai.customization': 'Domain-specific tuning',
	'landing.comparison.chatgpt.customization': 'Generic responses',

	// FAQ
	'landing.faq.heading': 'Frequently Asked Questions',
	'landing.faq.whatIsRag.question': 'What does RAG stand for?',
	'landing.faq.whatIsRag.answer':
		"RAG stands for Retrieval-Augmented Generation. It's an AI technique that combines the power of large language models with your own knowledge base. Instead of relying solely on the AI's training data, RAG systems retrieve relevant information from your documents and use it to generate accurate, source-cited answers.",
	'landing.faq.gdprCompliant.question': 'Is Botbakery Platform GDPR compliant?',
	'landing.faq.gdprCompliant.answer':
		'Yes, absolutely. Botbakery Platform is fully GDPR compliant and hosted in the EU. All data processing occurs within European data centers, your data never leaves the EU, and we follow strict data protection protocols. We provide data processing agreements (DPA) and comprehensive documentation for compliance officers.',
	'landing.faq.privateKnowledge.question': 'Can I integrate my own private knowledge?',
	'landing.faq.privateKnowledge.answer':
		"Yes! That's exactly what Botbakery Platform is built for. You can integrate internal documents, wikis, databases, technical documentation, and any other knowledge sources your organization uses. We handle the entire ETL pipeline, chunking, embedding generation, and deployment. Your knowledge remains private and secure.",
	'landing.faq.whyNotChatGPT.question': 'Why not just use plain ChatGPT?',
	'landing.faq.whyNotChatGPT.answer':
		"While ChatGPT is powerful, it has limitations for enterprise use: No source citations—you can't verify where information comes from. No private knowledge—can't access your internal documents. Hallucinations—may generate plausible but incorrect information. Generic responses—not customized for your domain. Botbakery Platform solves these with full source citations, private knowledge integration, and domain-specific customization—all while being GDPR compliant and EU-hosted.",
	'landing.faq.useCases.question': 'What can I use an Botbakery Platform bot for?',
	'landing.faq.useCases.answer':
		'Common use cases include: Internal knowledge management—give employees instant access to company knowledge. Customer success—automate support with accurate, cited answers. Technical documentation—help developers find API details and code examples. Research & analysis—search through reports, studies, and data. Compliance & legal—query policies, regulations, and legal documents. Training & onboarding—provide new hires with interactive knowledge access.',
	'landing.faq.trustAnswers.question': 'Can I trust the answers?',
	'landing.faq.trustAnswers.answer':
		'While no AI system can guarantee 100% accuracy, Botbakery Platform provides unprecedented transparency through full source citations. Every answer includes references to the exact documents and passages used, allowing you to verify information yourself. This dramatically reduces hallucinations and builds trust. Always review sources for critical decisions.',
	'landing.faq.cost.question': 'What does it cost?',
	'landing.faq.cost.answer':
		'Botbakery Platform is a custom integration service, not an off-the-shelf product. Pricing depends on your specific needs: data volume, update frequency, customization requirements, and deployment method. Contact us for a personalized quote. We focus on delivering quality, domain-specific solutions rather than one-size-fits-all packages.',
	'landing.faq.integrationTime.question': 'How long does integration take?',
	'landing.faq.integrationTime.answer':
		"Integration typically takes 2-6 weeks depending on complexity. Simple document imports can be up and running in days, while complex multi-source integrations with custom workflows may take longer. We'll provide a detailed timeline during the initial consultation.",
	'landing.faq.aiModels.question': 'What AI models do you support?',
	'landing.faq.aiModels.answer':
		'We support all major AI vendors including OpenAI (GPT models), Anthropic (Claude), and Scaleway/Mistral. We help you choose the best model for your use case based on language support, cost, and performance requirements.',

	// CTA
	'landing.cta.heading': 'Ready to Build Your Knowledge Assistant?',
	'landing.cta.description': 'Get started with custom RAG integration today',
	'landing.cta.button': 'Book a Demo'
};

const de: typeof en = {
	'common.save': 'Speichern',
	'common.logout': 'Ausloggen',
	'common.signIn': 'Anmelden',
	'common.rename': 'Umbenennen',
	'common.delete': 'Löschen',
	'common.sources': 'Quellen',
	'common.hello': 'Hallo',
	'common.by': 'von',
	'common.and': 'und',
	'common.privacy': 'Datenschutz',
	'common.imprint': 'Impressum',
	'common.terms': 'Nutzungsbedingungen',
	'common.copy': 'Kopieren',
	'common.copied': 'Kopiert!',
	'common.close': 'Schließen',

	'releaseNotes.title': 'Release Notes',
	'releaseNotes.current': 'Aktuelle Version',
	'releaseNotes.previous': 'Frühere Versionen',
	'releaseNotes.userView': 'Nutzeransicht',

	'error.network':
		'Keine Verbindung mit dem Internet. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
	'error.overloaded':
		'Der Service ist vorübergehend überlastet. Bitte versuche es in einem Moment erneut.',
	'error.notFound': 'Nicht gefunden',
	'error.unknown': 'Unbekannter Fehler',

	'nav.data': 'Wissensspeicher',
	'nav.briefing': 'Tägliches Briefing',
	'nav.history': 'Alle Chats',
	'nav.tenantAdminSettings': 'Admin-Einstellungen',
	'nav.users': 'Nutzerverwaltung',
	'nav.recentChats': 'Letzte Chats',

	'users.title': 'Nutzerverwaltung',
	'users.empty': 'Keine Nutzer gefunden',
	'users.role': 'Rolle',
	'users.role.user': 'User',
	'users.role.operator': 'Operator',
	'users.role.admin': 'Admin',
	'users.conversations': 'Chats',
	'users.messages': 'Nachrichten',
	'users.tokens': 'Tokens',
	'users.created': 'Erstellt',
	'users.lastActivity': 'Letzte Aktivität',
	'users.never': 'Nie',
	'users.plan': 'Plan',
	'users.delete': 'Nutzer löschen',
	'users.delete.confirm': 'Nutzer wirklich löschen?',
	'users.delete.warning':
		'Das Nutzerkonto und alle zugehörigen Daten werden unwiderruflich gelöscht.',
	'users.itsYou': 'das bist du',
	'users.search': 'Nutzer suchen…',

	'briefing.title': 'Tägliches Briefing',
	'briefing.heading': 'Tägliches Parlamentsbriefing vom {{date}}',
	'briefing.emptyState': 'Kein Briefing für heute verfügbar. Schauen Sie morgen wieder vorbei!',
	'briefing.loading': 'Lade heutiges Briefing...',
	'briefing.errorLoading': 'Fehler beim Laden des Briefings',
	'briefing.coveragePeriod': 'Abdeckungszeitraum',
	'briefing.generatedOn': 'Generiert am',
	'briefing.footer.whatAre': 'Was sind tägliche Briefings?',
	'briefing.footer.description':
		'Tägliche Briefings sind automatisch generierte Zusammenfassungen der parlamentarischen Aktivitäten. Sie bieten einen prägnanten Überblick über die wichtigsten Debatten, Entscheidungen und Diskussionen.',
	'briefing.footer.howGenerated': 'Wie werden sie erstellt?',
	'briefing.footer.generationProcess':
		'Unser KI-System analysiert alle parlamentarischen Dokumente und Reden des vergangenen Tages, identifiziert Schlüsselthemen und erstellt eine strukturierte Zusammenfassung.',
	'briefing.footer.whenGenerated': 'Wann werden sie erstellt?',
	'briefing.footer.schedule':
		'Briefings werden in den frühen Morgenstunden generiert und decken Themen des Vortages ab.',

	'auth.signIn.title': 'Login',
	'auth.signIn.titleWithTenant': '{{tenant}} Login',
	'auth.signIn.subtitle': 'Melde dich bei deinem Botbakery-Konto an.',
	'auth.signIn.signinSubtitle': 'Gib dein Passwort ein, um auf dein Botbakery-Konto zuzugreifen.',
	'auth.signIn.email': 'E-Mail',
	'auth.signIn.password': 'Passwort',
	'auth.signIn.continueWithEmail': 'Weiter',
	'auth.signIn.or': 'oder',
	'auth.signIn.signInWithGoogle': 'Mit Google anmelden',
	'auth.signIn.signInWithMicrosoft': 'Mit Microsoft anmelden',
	'auth.signIn.forgotPassword': 'Passwort vergessen?',
	'auth.signIn.createAccount': 'Account erstellen',
	'auth.signIn.welcome': 'Willkommen!',
	'auth.signIn.welcomeBack': 'Willkommen zurück!',
	'auth.signIn.invalidEmail': 'Bitte gib eine gültige E-Mail-Adresse ein',
	'auth.signIn.fillAllFields': 'Bitte fülle alle Felder aus',

	'auth.reset.title': 'Passwort zurücksetzen',
	'auth.reset.message':
		'Gib die E-Mail adresse von deinem Acounnt hier ein und wir schicken dir einen reset-Link',
	'auth.reset.success':
		'Passwort-Reset für {email} angefordert. Falls diese E-Mail mit einem {{tenantName}} Account verknüpft ist, hast du eine E-Mail mit einem Reset-Link erhalten.',
	'auth.reset.backToLogin': 'Zurück zum Login',
	'auth.reset.email': 'E-Mail',
	'auth.reset.submit': 'Reset-Link senden',
	'auth.reset.error': 'Fehler beim Zurücksetzen des Passworts',
	'auth.confirmReset.title': 'Neues Passwort',
	'auth.confirmReset.success':
		'Passwort wurde erfolgreich gesetzt! Du kannst dich nun mit deinem neuen Passwort einloggen.',
	'auth.confirmReset.message': 'Bitte setze ein neues Passwort',
	'auth.confirmReset.password': 'Passwort',
	'auth.confirmReset.passwordConfirm': 'Passwort bestätigen',
	'auth.confirmReset.submit': 'Speichern',
	'auth.confirmReset.toLogin': 'Zum Login',

	'auth.signup.title': 'Account erstellen',
	'auth.signup.subtitle': 'Nur noch ein paar Angaben, um dein Botbakery-Konto einzurichten.',
	'auth.signup.firstName': 'Vorname',
	'auth.signup.lastName': 'Nachname',
	'auth.signup.password': 'Passwort',
	'auth.signup.passwordConfirm': 'Passwort bestätigen',
	'auth.signup.passwordsNotEqual': 'Passwörter stimmen nicht überein',
	'auth.signup.submit': 'Account erstellen',
	'auth.signup.notApproved':
		'Leider ist dein Account noch nicht freigeschaten. Versuch es später nochmal.',
	'auth.signup.success': 'Dein Account wurde erfolgreich angelegt! Du kannst dich nun einloggen.',
	'auth.signup.toLogin': 'Zum Login',
	'auth.signup.needInfo': 'Wir brauchen noch ein paar Infos von dir',
	'auth.signup.acceptTerms': 'Ich akzeptiere die {{terms}} und {{privacy}}',
	'auth.signup.termsRequired': 'Du musst die Nutzungsbedingungen akzeptieren',
	'auth.signup.fillAllFields': 'Bitte fülle alle Pflichtfelder aus',

	'auth.unsubscribe.title': 'Austragen',
	'auth.unsubscribe.success': 'Deine E-Mail wurde erfolgreich aus unserem System gelöscht.',
	'auth.unsubscribe.confirmMessage': 'Schade, dass du dich aus der Warteliste austragen möchtest.',
	'auth.unsubscribe.confirmQuestion': 'Bist du dir sicher?',
	'auth.unsubscribe.submit': 'Ja, löscht meine E-Mail Adresse',
	'auth.verify.successTitle': 'E-Mail bestätigt!',
	'auth.verify.successMessage':
		'Deine E-Mail-Adresse wurde verifiziert. Du kannst dich jetzt anmelden.',
	'auth.verify.toLogin': 'Anmelden',
	'auth.verify.errorTitle': 'Fehler',
	'auth.verify.errorMessage': 'Es gab leider einen Fehler bei der Verifizierung :(',

	'chat.welcome': 'wie kann ich dir heute weiter helfen?',
	'chat.new': 'Neuer Chat',
	'chat.info': 'Chat Info',
	'chat.rename': 'Chat Umbenennen',
	'chat.delete': 'Chat Löschen',
	'chat.delete.question': 'Möchtest du diesen Chat wirklich löschen?',
	'chat.delete.confirm': 'Ja, löschen',
	'chat.delete.cancel': 'Nein, nicht löschen',
	'chat.disclaimer': '{{tenantName}} kann Fehler machen',
	'chat.disclaimerCheckSources': 'Überprüfe alle Quellen immer sorgfältig',
	'chat.developedBy': 'Entwickelt von',
	'chat.placeholder': 'Frag mich was...',
	'chat.debugInfo': 'Debug Info',
	'chat.retry': 'Neu generieren',
	'chat.regenerate': 'Regenerieren',
	'chat.incomplete': 'Antwort gestoppt',
	'chat.incompleteTooltip':
		'Du hast die Generierung der Antwort unterbrochen bevor sie vollständig war',
	'chat.stopResponse': 'Antwort stoppen',
	'chat.webSearchEnabledLabel': 'Websuche erlauben um zusätzliche Informationen zu recherchieren',
	'chat.lastMessage': 'Letzte Nachricht',
	'chat.emptyHistory': 'Keine Chats vorhanden',
	'chat.unnamed': 'Unbenannter Chat',
	'chat.fetching.thinking': 'denke nach...',
	'chat.fetching.analyticalQuery': 'durchsuche Datenbank...',
	'chat.fetching.searchSources': 'suche Quellen...',
	'chat.fetching.sourcesFound': 'Quellen gefunden...',
	'chat.reasoning': 'Gedanken',

	'data.emptyState': 'Keine Daten verfügbar',
	'data.importedOn': 'Importiert am',
	'data.document': 'Dokument',
	'data.documents': 'Dokumente',
	'data.speech': 'Rede',
	'data.speeches': 'Reden',
	'data.openSource': 'Quelle öffnen',
	'data.loadError': 'Fehler beim Laden der Daten',
	'data.latestUpdate': 'Letztes Update',
	'data.documentsInKnowledgeStore': 'Dokumente im Wissensspeicher*',
	'data.documentTypesExplanation':
		'* Dokumente umfassen verschiedene Inhaltstypen wie Artikel, Gesetze, Reden und andere Dokumente.',
	'data.description':
		'Wir aktualisieren den Wissensspeicher regelmäßig mit neuen Daten. Alle hier aufgeführten Informationen stehen dem Bot zur Verfügung und können in Konversationen durchsucht und referenziert werden. Informationen, die nicht auf dieser Seite aufgeführt sind, sind für den Bot nicht zugänglich.',
	'data.topicsInDebate': 'Themen in dieser Debatte:',
	'data.tabs.resources': 'Ressourcen',
	'data.tabs.importJobs': 'Import Jobs',

	'data.noDocuments': 'Keine Dokumente in dieser Ressource',

	'docType.speech': 'Debatte im Bundestag',
	'docType.politician_bio': 'Person',
	'docType.eu_com_proposal': 'Commission Proposal',
	'docType.eu_ep_amendments_adopted': 'Adopted Amendments',
	'docType.eu_ep_cmt_opinion': 'Committee Opinion',
	'docType.eu_egp_briefing': 'EGP Internal Briefing',
	'docType.press_message': 'Parlamentsnachrichten "heute im bundestag"',
	'docType.podcast_transscript': 'Podcast Transkript',
	'docType.generic_document': 'Dokument',

	'sources.header': 'Quelldokumente',
	'sources.headerDetail': 'Quelldokument',
	'sources.documents': 'Dokumente',
	'sources.documentLink': 'Dokumentenlink',
	'sources.metadata': 'Metadaten',
	'sources.summary': 'Zusammenfassung',
	'sources.originalText': 'Originaltext',
	'sources.placeholder':
		'Quellen und Kontextinformationen werden hier auftauchen, sobald du mit der Konversation beginnst',
	'sources.primarySources': 'Wissensbasis',
	'sources.webSources': 'Webquellen',
	'sources.openWebSource': 'Webseite öffnen',
	'sources.description': 'Beschreibung',
	'sources.citedPassages': 'Zitierte Passagen',
	'sources.copyrightNotice':
		'Es werden nur zitierte Ausschnitte angezeigt. Besuche den Quellenlink, um den vollständigen Inhalt zu lesen.',

	'settings.locale': 'Sprache',
	'settings.locale.de': 'Deutsch',
	'settings.locale.en': 'Englisch',

	'settings.theme': 'Design',
	'settings.theme.light': 'Hell',
	'settings.theme.dark': 'Dunkel',
	'settings.theme.system': 'Systemstandard',

	'settings.title': 'Einstellungen',
	'settings.user.name': 'Name',
	'settings.user.firstName': 'Vorname',
	'settings.user.lastName': 'Nachname',
	'settings.user.bio': 'Bio',
	'settings.user.email': 'E-Mail',
	'settings.user.username': 'Username',
	'settings.user.defaultModel': 'Standard Model',
	'settings.user.defaultEmbeddingsVendor': 'Standard Embeddings-Model',

	'settings.deleteAccount': 'Konto löschen',
	'settings.deleteAccount.title': 'Konto löschen',
	'settings.deleteAccount.warning':
		'Diese Aktion plant die Löschung deines Kontos. Alle deine Daten, einschließlich Unterhaltungen, Einstellungen und persönlicher Informationen, werden dauerhaft entfernt.',
	'settings.deleteAccount.gracePeriod':
		'Du hast 30 Tage Zeit, deine Meinung zu ändern. In diesem Zeitraum kannst du den Support kontaktieren, um dein Konto wiederherzustellen. Nach 30 Tagen werden alle Daten dauerhaft gelöscht.',
	'settings.deleteAccount.confirm': 'Ja, mein Konto löschen',
	'settings.deleteAccount.cancel': 'Abbrechen',

	'settings.tenant.title': 'Tenant-Einstellungen',
	'settings.tenant.name': 'Tenant-Name',
	'settings.tenant.primer': 'Primer',
	'settings.tenant.logo': 'Logo',
	'settings.tenant.language': 'Sprache',
	'settings.tenant.onboardingContent': 'Onboarding Inhalt (HTML, Popup beim ersten Einloggen)',
	'settings.tenant.responseStyle': 'Antwort-Stil',
	'settings.tenant.knowledgeBase': 'Wissensbasis-Kontext',
	'settings.tenant.featureFlags': 'Feature Flags',
	'settings.tenant.dailyBriefing': 'Tägliches Briefing',
	'settings.tenant.webSearch': 'Websuche',
	'settings.tenant.generalSettings': 'Allgemeine Einstellungen',
	'settings.tenant.systemPrompt': 'System-Prompt',
	'settings.tenant.chatSuggestions': 'Chat-Vorschläge',
	'settings.tenant.chatSuggestions.description':
		'Vorschläge erscheinen als klickbare Bubbles auf der Neuen-Chat-Seite',
	'settings.tenant.chatSuggestions.placeholder': 'Vorschlag eingeben...',
	'settings.tenant.chatSuggestions.add': 'Hinzufügen',
	'settings.tenant.chatSuggestions.empty': 'Noch keine Vorschläge hinzugefügt',
	'settings.tenant.knowledgeBase.flag': 'Wissensbasis',
	'settings.tenant.knowledgeBase.flag.description':
		'Aktiviert Zugriff auf Vektorsuche, Volltextsuche und Dokumentenabruf.',
	'settings.tenant.knowledgeBase.citationEngine': 'Strikte Zitate',
	'settings.tenant.knowledgeBase.citationEngine.description':
		'Verlangt vom Agenten, Quellen mit exakten Zitaten zu belegen. Deaktivieren für Assistenten ohne strenge Quellenangaben.',
	'settings.tenant.dailyBriefing.description': 'Unterseite "Tägliches Briefing" ist sichtbar.',
	'settings.tenant.webSearch.description':
		'Websuche als Sekundärquelle für ergänzende Informationen.',
	'settings.tenant.webSearch.alwaysOn': 'Immer aktiv',
	'settings.tenant.webSearch.alwaysOn.description':
		'Websuche ist immer aktiv. Der Umschalter im Chat-Eingabefeld wird ausgeblendet.',
	'settings.tenant.queryClassification': 'Anfrageklassifikation',
	'settings.tenant.queryClassification.description':
		'Klassifiziert Anfragen vor der Verarbeitung, um Retrieval und Thinking bei einfachen Anfragen zu überspringen. Deaktivieren für Modelle mit adaptivem Thinking.',
	'settings.tenant.allowedSearchDomains': 'Erlaubte Suchdomains',
	'settings.tenant.allowedSearchDomains.description':
		'Websuche auf diese Domains einschränken. Leer lassen, um alle Domains zu erlauben.',
	'settings.tenant.allowedSearchDomains.placeholder': 'z.B. tagesschau.de',
	'settings.tenant.allowedSearchDomains.add': 'Hinzufügen',
	'settings.tenant.allowedSearchDomains.empty':
		'Keine Domains eingetragen — alle Domains sind erlaubt',
	'settings.tenant.welcomeMessage': 'Willkommensnachricht',
	'settings.tenant.welcomeMessage.description':
		'Individuelle Willkommensnachricht auf der neuen Chat-Seite. Leer lassen für den Standard.',
	'settings.tenant.defaultModel': 'Standard-Modell',

	'settings.tenant.nav.header': 'Admin-Einstellungen',
	'settings.tenant.nav.back': 'Zurück',
	'settings.tenant.nav.general': 'Allgemein',
	'settings.tenant.nav.knowledgeBase': 'Wissensbasis',
	'settings.tenant.nav.webSearch': 'Websuche',
	'settings.tenant.nav.queryClassification': 'Anfrageklassifikation',
	'settings.tenant.nav.apiKeys': 'API-Keys',

	'settings.tenant.defaultClassification': 'Standard-Klassifikation',
	'settings.tenant.defaultClassification.description':
		'Verhalten wenn die Anfrageklassifikation deaktiviert ist. Diese Einstellungen bestimmen wie jede Anfrage behandelt wird.',
	'settings.tenant.defaultClassification.enableThinking': 'Thinking aktivieren',
	'settings.tenant.defaultClassification.hideThinking': 'Gedanken ausblenden',
	'settings.tenant.defaultClassification.enableTools': 'Tools aktivieren',
	'settings.tenant.defaultClassification.temperature': 'Temperatur',
	'settings.tenant.defaultClassification.maxIterations': 'Max. Iterationen',

	'tenant.create.title': 'Neuer Tenant',
	'tenant.create.name': 'Tenant-Name',
	'tenant.create.slug': 'Slug (URL-Kennung)',
	'tenant.create.language': 'Sprache',
	'tenant.create.submit': 'Tenant erstellen',
	'tenant.create.tooltip': 'Tenant erstellen',

	'apiKeys.title': 'API Keys',
	'apiKeys.createNew': 'Neuen Key erstellen',
	'apiKeys.noKeys': 'Noch keine API Keys. Erstelle einen, um loszulegen.',
	'apiKeys.active': 'Aktiv',
	'apiKeys.inactive': 'Inaktiv',
	'apiKeys.created': 'Erstellt',
	'apiKeys.lastUsed': 'Zuletzt verwendet',
	'apiKeys.expires': 'Läuft ab',
	'apiKeys.neverExpires': 'Läuft nie ab',
	'apiKeys.requests': 'Anfragen',
	'apiKeys.deleteConfirm': 'Möchtest du den API Key "{{name}}" wirklich löschen?',

	'sharedLinks.title': 'Geteilte Links',
	'sharedLinks.createNew': 'Geteilten Link erstellen',
	'sharedLinks.noLinks': 'Noch keine geteilten Links. Erstelle einen, um loszulegen.',
	'sharedLinks.deleteConfirm': 'Möchtest du diesen geteilten Link wirklich löschen?',
	'sharedLinks.create.title': 'Geteilten Link erstellen',
	'sharedLinks.create.generating': 'Geteilten Link wird erstellt...',

	'apiKeys.create.title': 'API Key erstellen',
	'apiKeys.create.keyName': 'Key-Name',
	'apiKeys.create.keyType': 'Key-Typ',
	'apiKeys.create.keyType.widget': 'Widget',
	'apiKeys.create.keyType.sharedLink': 'Geteilter Link',
	'apiKeys.create.allowedOrigins': 'Erlaubte Origins (kommagetrennt)',
	'apiKeys.create.validityPeriod': 'Gültigkeitsdauer',
	'apiKeys.create.neverExpires': 'Läuft nie ab',
	'apiKeys.create.days': '{{count}} Tage',
	'apiKeys.create.year': '1 Jahr',
	'apiKeys.create.anonymousConversations': 'Anonyme Konversationen',
	'apiKeys.create.anonymousConversationsHelp':
		'Aktiviere dies, wenn du es zum Einbetten des Widgets verwenden möchtest',
	'apiKeys.create.submit': 'Key erstellen',
	'apiKeys.create.warning':
		'Stelle sicher, dass du deinen API Key jetzt kopierst. Du wirst ihn nicht noch einmal sehen können!',
	'apiKeys.create.copyToClipboard': 'In Zwischenablage kopieren',
	'apiKeys.create.done': 'Fertig',
	'apiKeys.create.sharedLinkSuccess': 'Teile diesen Link mit anderen:',

	'onboarding.title': 'Willkommen!',
	'onboarding.getStarted': "Los geht's",
	'onboarding.showDialog': 'Willkommensdialog anzeigen',

	'plan.free': 'Free',
	'plan.basic': 'Basic',
	'plan.unlimited': 'Unlimited',
	'plan.conversations': '{{current}}/{{max}} Chats',
	'plan.conversationsUnlimited': 'Unbegrenzte Chats',
	'plan.upgrade': 'Plan upgraden',
	'plan.upgrade.title': 'Plan upgraden',
	'plan.upgrade.description':
		'Erhalte mehr Chats und Nachrichten pro Chat durch ein Upgrade deines Plans.',
	'plan.upgrade.currentPlan': 'Aktueller Plan',
	'plan.upgrade.features': 'Features',
	'plan.upgrade.conversationsLimit': '{{count}} Chats',
	'plan.upgrade.conversationsUnlimited': 'Unbegrenzte Chats',
	'plan.upgrade.messagesLimit': '{{count}} Nachrichten pro Chat',
	'plan.upgrade.messagesUnlimited': 'Unbegrenzte Nachrichten pro Chat',
	'plan.upgrade.custom': 'Custom',
	'plan.upgrade.customDataIntegration': 'Individuelle Datenintegration',
	'plan.upgrade.dedicatedSupport': 'Persönlicher Ansprechpartner',
	'plan.upgrade.widgetEmbedding': 'Widget-Einbettung',
	'plan.upgrade.customBranding': 'Eigenes Branding',
	'plan.upgrade.higherPerformanceModels': 'Leistungsstärkere Foundation-Modelle',
	'plan.upgrade.chooseModelPerRequest': 'Modellauswahl für jede Anfrage',
	'plan.upgrade.ownModelIntegration': 'Eigenes Modell integrieren',
	'plan.upgrade.onPremise': 'On-Premise-Bereitstellung',
	'plan.upgrade.earlyAdopterTitle': 'Early Adopter Bonus',
	'plan.upgrade.earlyAdopterDescription':
		'Als Dankeschön für deine frühe Anmeldung bei Botbakery: Verdopple deine Limits kostenlos!',
	'plan.upgrade.claimBonus': 'Bonus einlösen',
	'plan.upgrade.comingSoon': 'Demnächst verfügbar',
	'plan.upgrade.contact': 'Kontaktiere uns',
	'plan.upgrade.contactDescription': 'Interesse an einem Upgrade? Melde dich bei uns.',
	'plan.upgrade.earlyAdopterNotice':
		'Du bist im Basic-Plan als Dankeschön für deine frühe Anmeldung!',
	'plan.limitReached.title': 'Chat-Limit erreicht',
	'plan.limitReached.description':
		'Du hast alle {{count}} Chats in deinem {{plan}}-Plan verwendet. Upgrade um weiterzuchatten.',
	'plan.limitReached.cta': 'Plan upgraden',

	// Landing Page
	'landing.hero.brandTag': 'Ein Angebot von der',
	'landing.hero.headline': 'Die Chatbot-Plattform, der du vertrauen kannst',
	'landing.hero.subheadline':
		'Botbakery Platform integriert deine Wissensquellen mit dem LLM deiner Wahl. Mit verifizierbaren Quellenangaben, DSGVO-konform und in der EU gehostet.',
	'landing.hero.cta': 'Demo vereinbaren',

	// Value Propositions
	'landing.benefits.heading': 'Warum Botbakery Platform?',
	'landing.benefits.citations.title': 'Verifizierbare Antworten durch präzise Zitate',
	'landing.benefits.customKnowledge.title': 'Individuelles Wissen für dich integriert',
	'landing.benefits.verifiable.title': 'Verifizierbare Antworten',
	'landing.benefits.verifiable.text':
		'Jede Antwort enthält vollständige Quellenangaben, damit du Informationen verifizieren und Halluzinationen verhindern kannst.',
	'landing.benefits.private.title': 'Deine privaten Wissensinhalte',
	'landing.benefits.private.text':
		'Integriere interne Dokumente, Wikis und Datenbanken. Dein Wissen bleibt sicher und privat.',
	'landing.benefits.gdpr.title': 'DSGVO-konform',
	'landing.benefits.gdpr.text':
		'In der EU gehostet mit vollständiger DSGVO-Konformität. Deine Daten verlassen niemals Europa.',
	'landing.benefits.custom.title': 'Individuelle Integrationen',
	'landing.benefits.custom.text':
		'Bereitstellung über API, Web-Widget oder individuelle Integration. Entwickelt für deinen Workflow.',

	// How It Works
	'landing.howItWorks.heading': 'So funktioniert es',
	'landing.howItWorks.step1.title': 'Verbinde dein Wissen',
	'landing.howItWorks.step1.description':
		'Importiere Dokumente, Wikis, Datenbanken und alle Wissensquellen, die deine Organisation nutzt.',
	'landing.howItWorks.step2.title': 'Passe deinen Assistenten an',
	'landing.howItWorks.step2.description':
		'Konfiguriere RAG-Parameter, wähle KI-Modelle aus und passe alles für deine Domäne an.',
	'landing.howItWorks.step3.title': 'Überall bereitstellen',
	'landing.howItWorks.step3.description':
		'Nutze es über API, binde es als Widget ein oder integriere es in deine vorhandenen Tools.',

	// RAG Pipeline (detailed)
	'landing.ragPipeline.heading': 'Wie funktioniert die Botbakery Platform?',
	'landing.ragPipeline.intro':
		'Retrieval-Augmented Generation (RAG) kombiniert gezieltes Durchsuchen eurer Dokumente mit der Sprachfähigkeit moderner KI. Anders als generische Chatbots, die "aus dem Bauch heraus" antworten, holt Botbakery Platform sich erst die relevanten Fakten aus euren Datenbanken – und generiert dann eine präzise Antwort auf Basis dieser Quellen. Das Resultat: verlässliche, belegbare Antworten statt halluzinierter "Fakten".',
	'landing.ragPipeline.step1.title': 'Dokument-Vorverarbeitung',
	'landing.ragPipeline.step1.description':
		'Wir verarbeiten eure Dokumente mit intelligentem Chunking, erstellen Zusammenfassungen und extrahieren Metadaten für optimale Durchsuchbarkeit',
	'landing.ragPipeline.step2.title': 'Intent Detection',
	'landing.ragPipeline.step2.description':
		'Wir analysieren die Nutzeranfrage, um ihre Intention zu verstehen – das leitet die Pipeline zu relevanteren Ergebnissen und bestimmt, ob Retrieval notwendig ist oder das Modell direkt antworten kann',
	'landing.ragPipeline.step3.title': 'Multi-Stage Retrieval',
	'landing.ragPipeline.step3.description':
		'Wir führen Retrieval mehrfach in aufeinanderfolgenden Stufen durch und kommen dabei dem benötigten Wissen immer näher – beginnend mit Dokumentzusammenfassungen, dann eingrenzend auf spezifische Passagen',
	'landing.ragPipeline.step4.title': 'Reranking',
	'landing.ragPipeline.step4.description':
		'Wir sortieren alle gefundenen Ergebnisse nach tatsächlicher Relevanz für die konkrete Frage und wählen die optimalen Informationen für den KI-Kontext aus',
	'landing.ragPipeline.step5.title': 'Antwortgenerierung & Zitation',
	'landing.ragPipeline.step5.description':
		'Wir generieren eine präzise Antwort basierend auf den gefundenen Quellen und fügen automatisch Quellenangaben ein, die jede Aussage zurück zu den Originaldokumenten verlinken – für volle Transparenz',

	// Use Cases
	'landing.useCases.heading': 'Für deinen Workflow entwickelt',
	'landing.useCases.internal.title': 'Internes Wissensmanagement',
	'landing.useCases.internal.description':
		'Gib deinem Team sofortigen Zugriff auf Unternehmenswissen, Richtlinien und Dokumentation.',
	'landing.useCases.customer.title': 'Customer Success',
	'landing.useCases.customer.description':
		'Automatisiere Support mit präzisen, zitierten Antworten auf Kundenfragen.',
	'landing.useCases.technical.title': 'Technische Dokumentation',
	'landing.useCases.technical.description':
		'Hilf Entwicklern, API-Details, Code-Beispiele und Integrationsanleitungen zu finden.',
	'landing.useCases.research.title': 'Forschung & Analyse',
	'landing.useCases.research.description':
		'Durchsuche Berichte, Studien und Daten mit KI-gestützten Insights.',

	// Comparison
	'landing.comparison.heading': 'Warum nicht einfach ChatGPT verwenden?',
	'landing.comparison.sources': 'Quellenangaben',
	'landing.comparison.astlai.sources': 'Vollständige Quellenangaben für jede Antwort',
	'landing.comparison.chatgpt.sources': 'Keine Quellenangaben',
	'landing.comparison.knowledge': 'Privates Wissen',
	'landing.comparison.astlai.knowledge': 'Vollständiger Zugriff auf deine Dokumente',
	'landing.comparison.chatgpt.knowledge': 'Nur öffentliche Trainingsdaten',
	'landing.comparison.compliance': 'DSGVO-Konformität',
	'landing.comparison.astlai.compliance': 'In der EU gehostet, DSGVO-konform',
	'landing.comparison.chatgpt.compliance': 'In den USA gehostet',
	'landing.comparison.customization': 'Anpassung',
	'landing.comparison.astlai.customization': 'Domänenspezifisches Tuning',
	'landing.comparison.chatgpt.customization': 'Generische Antworten',

	// FAQ
	'landing.faq.heading': 'Häufig gestellte Fragen',
	'landing.faq.whatIsRag.question': 'Wofür steht RAG?',
	'landing.faq.whatIsRag.answer':
		'RAG steht für Retrieval-Augmented Generation (Abruf-erweiterte Generierung). Es ist eine KI-Technik, die die Leistung großer Sprachmodelle mit deiner eigenen Wissensbasis kombiniert. Anstatt sich ausschließlich auf die Trainingsdaten der KI zu verlassen, rufen RAG-Systeme relevante Informationen aus deinen Dokumenten ab und verwenden sie, um präzise Antworten mit Quellenangaben zu generieren.',
	'landing.faq.gdprCompliant.question': 'Ist Botbakery Platform DSGVO-konform?',
	'landing.faq.gdprCompliant.answer':
		'Ja, absolut. Unsere Plattform ist vollständig DSGVO-konform und in der EU gehostet. Die gesamte Datenverarbeitung erfolgt in europäischen Rechenzentren, deine Daten verlassen niemals die EU, und wir befolgen strenge Datenschutzprotokolle. Wir stellen Auftragsverarbeitungsverträge (AVV) und umfassende Dokumentation für Datenschutzbeauftragte bereit.',
	'landing.faq.privateKnowledge.question': 'Kann ich mein eigenes privates Wissen integrieren?',
	'landing.faq.privateKnowledge.answer':
		'Ja! Genau dafür ist Botbakery Platform entwickelt. Du kannst interne Dokumente, Wikis, Datenbanken, technische Dokumentation und alle anderen Wissensquellen deiner Organisation integrieren. Wir kümmern uns um die gesamte ETL-Pipeline, Chunking, Embedding-Generierung und Bereitstellung. Dein Wissen bleibt privat und sicher.',
	'landing.faq.whyNotChatGPT.question': 'Warum nicht einfach ChatGPT verwenden?',
	'landing.faq.whyNotChatGPT.answer':
		'ChatGPT ist zwar leistungsstark, hat aber Einschränkungen für den Unternehmenseinsatz: Keine Quellenangaben—du kannst nicht nachvollziehen, woher Informationen stammen. Kein privates Wissen—kein Zugriff auf deine internen Dokumente. Halluzinationen—kann plausible, aber falsche Informationen generieren. Generische Antworten—nicht auf deine Domäne zugeschnitten. Botbakery Platform löst diese Probleme mit vollständigen Quellenangaben, Integration privater Wissensinhalte und domänenspezifischer Anpassung—alles DSGVO-konform und in der EU gehostet.',
	'landing.faq.useCases.question': 'Wofür kann ich einen Botbakery Platform Bot verwenden?',
	'landing.faq.useCases.answer':
		'Häufige Anwendungsfälle sind: Internes Wissensmanagement—gib Mitarbeitern sofortigen Zugriff auf Unternehmenswissen. Customer Success—automatisiere Support mit präzisen, zitierten Antworten. Technische Dokumentation—hilf Entwicklern, API-Details und Code-Beispiele zu finden. Forschung & Analyse—durchsuche Berichte, Studien und Daten. Compliance & Recht—frage Richtlinien, Vorschriften und Rechtsdokumente ab. Schulung & Onboarding—biete neuen Mitarbeitern interaktiven Wissenszugang.',
	'landing.faq.trustAnswers.question': 'Kann ich den Antworten vertrauen?',
	'landing.faq.trustAnswers.answer':
		'Obwohl kein KI-System 100%ige Genauigkeit garantieren kann, bietet Botbakery Platform beispiellose Transparenz durch vollständige Quellenangaben. Jede Antwort enthält Verweise auf die exakten Dokumente und Passagen, die verwendet wurden, sodass du Informationen selbst überprüfen kannst. Dies reduziert Halluzinationen drastisch und schafft Vertrauen. Überprüfe immer die Quellen für kritische Entscheidungen.',
	'landing.faq.cost.question': 'Was kostet es?',
	'landing.faq.cost.answer':
		'Die Botbakery Plattform ist ein individueller Integrationsdienst, kein fertiges Produkt. Die Preise hängen von deinen spezifischen Anforderungen ab: Datenvolumen, Aktualisierungshäufigkeit, Anpassungswünsche und Bereitstellungsmethode. Kontaktiere uns für ein personalisiertes Angebot. Wir konzentrieren uns auf die Bereitstellung qualitativ hochwertiger, domänenspezifischer Lösungen statt Einheitslösungen.',
	'landing.faq.integrationTime.question': 'Wie lange dauert die Integration?',
	'landing.faq.integrationTime.answer':
		'Die Integration dauert in der Regel 2-6 Wochen, abhängig von der Komplexität. Einfache Dokumentenimporte können in wenigen Tagen einsatzbereit sein, während komplexe Multi-Quellen-Integrationen mit benutzerdefinierten Workflows länger dauern können. Wir geben dir während der Erstberatung eine detaillierte Zeitplanung.',
	'landing.faq.aiModels.question': 'Welche KI-Modelle unterstützt ihr?',
	'landing.faq.aiModels.answer':
		'Wir unterstützen alle großen KI-Anbieter, darunter OpenAI (GPT-Modelle), Anthropic (Claude) und Scaleway/Mistral. Wir helfen dir, das beste Modell für deinen Anwendungsfall basierend auf Sprachunterstützung, Kosten und Leistungsanforderungen auszuwählen.',

	// CTA
	'landing.cta.heading': 'Bereit, deinen Wissensassistenten zu erstellen?',
	'landing.cta.description': 'Starte noch heute mit einer individuellen RAG-Integration',
	'landing.cta.button': 'Demo buchen'
};

export const translations = { en, de };
export type Locale = keyof typeof translations;
export type I18nKey = keyof typeof en;

export const locales = Object.keys(translations) as Locale[];
